import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
if ("serviceWorker" in navigator && import.meta.env.PROD) navigator.serviceWorker.register("/sw.js").then(registration => {
  const announceUpdate = () => {
    if (registration.waiting && navigator.serviceWorker.controller)
      window.dispatchEvent(new CustomEvent("memohub-update", { detail: registration }));
  };
  registration.addEventListener("updatefound", () => registration.installing?.addEventListener("statechange", announceUpdate));
  announceUpdate();
  const check = () => {
    if (document.visibilityState === "visible" && navigator.onLine) void registration.update().catch(() => {});
  };
  document.addEventListener("visibilitychange", check);
  window.addEventListener("online", check);
  window.setInterval(check, 60000);
});
